/// <reference path="../ObjectDataBuilder.ts" />
/// <reference path="../Navigation.ts" />

namespace SPA
{
	export namespace Realtor
	{

		export class ModernizationBuilder
			extends ObjectDataBuilder<Wollmilch.Data.Building>
		{
			private	m_Modernization: ui.Box.Box;
			private m_Form: ui.Form.Form;

			public constructor( data: Wollmilch.Data.Building, navigation: Navigation  )
			{
				super( data );

				this.m_Modernization	= new ui.Box.Box();

				// Update
				this.m_Form = new ui.Form.Form(
					{
						action: 'building/update/' + this.m_Data.ID,
						method: 'PATCH',
						static: false,
						notSwitchable: true,
						editButtonContext: 'primary',
						submit: ( method: ui.Form.FormMethod, action: string, parameter: ui.Form.IFormParameter  ) =>
						{
							new Wollmilch.AJAX(
								{
									method,
									url: action,
									data: parameter,
									on:
									{
										success: ( text: string ): void =>
										{
											const obj = Wollmilch.jsonize( text );

											if ( obj && obj.success === true )
											{
												app.addToast({ timeout: Number(app.getConfigValue("ToastTimeout")), body: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.MODERNIZATION.success_edit' ) ], context: 'success' });
											}
											else
											{
												app.addToast({ timeout: Number(app.getConfigValue("ToastTimeout")), body: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.MODERNIZATION.error_edit' ) ], context: 'danger' });
											}
										}
									}
								},
								Wollmilch.AJAXCallbase_e.REALTOR
							).send();

						}
					}
				);
				this.m_Form.Initialize();
			}

			public rebuild( root: ui.base.BaseHTMLElement|JQuery<HTMLElement>, navigation: Navigation ): ModernizationBuilder
			{
				this.m_Form.rebuild( root.empty() );

				this.showCompleteModernization();

				return this;
			}

			private showCompleteModernization(): void
			{
				this.showModernization();

				// Button
				new ui.Box.Box()
					.append( $( this.m_Form.Buttons.submit.getElement() ).text( app.getMessage( 'Aux.SAVE_BTN' ) ) )
					// .append( $( this.m_Form.Buttons.reset.getElement() ).text( app.getMessage( 'Aux.RESET_BTN' ) ) )
					.append( $( this.m_Form.Buttons.cancel.getElement() ).text( app.getMessage( 'Aux.ABORT_BTN' ) ) )
				.appendTo( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );
			}

			private showModernization(): void
			{
				this.m_Modernization.clearTitle();
				this.m_Modernization.addTitle( app.getMessage( 'Realtor.OBJECT.TITLE.MODERNIZATION' ) );
				this.m_Modernization.rebuild( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				// Verbesserungsmassnahmen
				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => { this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };
				let fg = ui.$$.div()
				.append( ui.$$.h( 6, app.getMessage( 'Realtor.OBJECT.LABEL.MODERNIZATION.ImprovementMeasures' ) ).addClass( 'text-muted col-xs-12 col-md-5' ) )
				.append( ui.$$.h( 6, app.getMessage( 'Realtor.OBJECT.LABEL.MODERNIZATION.percent' ) ).addClass( 'text-muted col-xs-12 col-md-5' ) )
				.append( ui.$$.h( 6, app.getMessage( 'Realtor.OBJECT.LABEL.MODERNIZATION.year' ) ).addClass( 'text-muted col-xs-12 col-md-2' ) )
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementMeasures.Window' ) ).addClass( 'control-label col-xs-12 col-md-5' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'ImprovementMeasures.Window.percent',
							required: false,
							value: [
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step2',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step3',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step4',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step5'
							],
							sentinal: 'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step1',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					.value( this.m_Data.Data.Modernization.ImprovementMeasures.Window.percent ),
					[ 'col-xs-12', 'col-md-5' ]
				);
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Data.Modernization.ImprovementMeasures.Window.year || '',
						{
							name: 'ImprovementMeasures.Window.year',
							placeholder: '',
							required: false
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-2' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementMeasures.Electricity' ) ).addClass( 'control-label col-xs-12 col-md-5' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'ImprovementMeasures.Electricity.percent',
							required: false,
							value: [
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step2',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step3',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step4',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step5'
							],
							sentinal: 'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step1',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					.value( this.m_Data.Data.Modernization.ImprovementMeasures.Electricity.percent ),
					[ 'col-xs-12', 'col-md-5' ]
				);
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Data.Modernization.ImprovementMeasures.Electricity.year || '',
						{
							name: 'ImprovementMeasures.Electricity.year',
							placeholder: '',
							required: false
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-2' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementMeasures.Gas' ) ).addClass( 'control-label col-xs-12 col-md-5' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'ImprovementMeasures.Gas.percent',
							required: false,
							value: [
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step2',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step3',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step4',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step5'
							],
							sentinal: 'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step1',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					.value( this.m_Data.Data.Modernization.ImprovementMeasures.Gas.percent ),
					[ 'col-xs-12', 'col-md-5' ]
				);
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Data.Modernization.ImprovementMeasures.Gas.year || '',
						{
							name: 'ImprovementMeasures.Gas.year',
							placeholder: '',
							required: false
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-2' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementMeasures.Water' ) ).addClass( 'control-label col-xs-12 col-md-5' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'ImprovementMeasures.Water.percent',
							required: false,
							value: [
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step2',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step3',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step4',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step5'
							],
							sentinal: 'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step1',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					.value( this.m_Data.Data.Modernization.ImprovementMeasures.Water.percent ),
					[ 'col-xs-12', 'col-md-5' ]
				);
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Data.Modernization.ImprovementMeasures.Water.year || '',
						{
							name: 'ImprovementMeasures.Water.year',
							placeholder: '',
							required: false
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-2' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementMeasures.Sewage' ) ).addClass( 'control-label col-xs-12 col-md-5' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'ImprovementMeasures.Sewage.percent',
							required: false,
							value: [
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step2',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step3',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step4',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step5'
							],
							sentinal: 'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step1',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					.value( this.m_Data.Data.Modernization.ImprovementMeasures.Sewage.percent ),
					[ 'col-xs-12', 'col-md-5' ]
				);
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Data.Modernization.ImprovementMeasures.Sewage.year || '',
						{
							name: 'ImprovementMeasures.Sewage.year',
							placeholder: '',
							required: false
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-2' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementMeasures.Heating' ) ).addClass( 'control-label col-xs-12 col-md-5' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'ImprovementMeasures.Heating.percent',
							required: false,
							value: [
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step2',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step3',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step4',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step5'
							],
							sentinal: 'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step1',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					.value( this.m_Data.Data.Modernization.ImprovementMeasures.Heating.percent ),
					[ 'col-xs-12', 'col-md-5' ]
				);
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Data.Modernization.ImprovementMeasures.Heating.year || '',
						{
							name: 'ImprovementMeasures.Heating.year',
							placeholder: '',
							required: false
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-2' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementMeasures.Bathroom' ) ).addClass( 'control-label col-xs-12 col-md-5' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'ImprovementMeasures.Bathroom.percent',
							required: false,
							value: [
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step2',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step3',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step4',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step5'
							],
							sentinal: 'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step1',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					.value( this.m_Data.Data.Modernization.ImprovementMeasures.Bathroom.percent ),
					[ 'col-xs-12', 'col-md-5' ]
				);
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Data.Modernization.ImprovementMeasures.Bathroom.year || '',
						{
							name: 'ImprovementMeasures.Bathroom.year',
							placeholder: '',
							required: false
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-2' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementMeasures.Interior' ) ).addClass( 'control-label col-xs-12 col-md-5' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'ImprovementMeasures.Interior.percent',
							required: false,
							value: [
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step2',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step3',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step4',
								'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step5'
							],
							sentinal: 'Realtor.OBJECT.INPUT.MODERNIZATION.ImprovementSteps.step1',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					.value( this.m_Data.Data.Modernization.ImprovementMeasures.Interior.percent ),
					[ 'col-xs-12', 'col-md-5' ]
				);
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Data.Modernization.ImprovementMeasures.Interior.year || '',
						{
							name: 'ImprovementMeasures.Interior.year',
							placeholder: '',
							required: false
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-2' ]
				);

				// Erneuerungen
				fg = ui.$$.div()
				.append( ui.$$.h( 6, app.getMessage( 'Realtor.OBJECT.LABEL.MODERNIZATION.Renewals' ) ).addClass( 'text-muted col-xs-12 col-md-5' ) )
				.append( ui.$$.h( 6, '' ).addClass( 'text-muted col-xs-12 col-md-5' ) )
				.append( ui.$$.h( 6, app.getMessage( 'Realtor.OBJECT.LABEL.MODERNIZATION.year' ) ).addClass( 'text-muted col-xs-12 col-md-2' ) )
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.Renewals.Roof' ) ).addClass( 'control-label col-xs-12 col-md-5' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'Renewals.Roof.status',
							required: false,
							value: [
								'Realtor.OBJECT.INPUT.MODERNIZATION.RenewalsSteps.step2'
							],
							sentinal: 'Realtor.OBJECT.INPUT.MODERNIZATION.RenewalsSteps.step1',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					.value( this.m_Data.Data.Modernization.Renewals.Roof.status ),
					[ 'col-xs-12', 'col-md-5' ]
				);
				addObjDataInput(
					new ui.Form.TextInput( this.m_Data.Data.Modernization.Renewals.Roof.year || '', { name: 'Renewals.Roof.year', placeholder: '', required: false } ).rebuild( fg ),
					[ 'col-xs-12', 'col-md-2' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.Renewals.Thermal' ) ).addClass( 'control-label col-xs-12 col-md-5' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'Renewals.Thermal.status',
							required: false,
							value: [
								'Realtor.OBJECT.INPUT.MODERNIZATION.RenewalsSteps.step2'
							],
							sentinal: 'Realtor.OBJECT.INPUT.MODERNIZATION.RenewalsSteps.step1',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					.value( this.m_Data.Data.Modernization.Renewals.Thermal.status ),
					[ 'col-xs-12', 'col-md-5' ]
				);
				addObjDataInput(
					new ui.Form.TextInput( this.m_Data.Data.Modernization.Renewals.Thermal.year || '', { name: 'Renewals.Thermal.year', placeholder: '', required: false } ).rebuild( fg ),
					[ 'col-xs-12', 'col-md-2' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.Renewals.Bathrooms' ) ).addClass( 'control-label col-xs-12 col-md-5' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'Renewals.Bathrooms.status',
							required: false,
							value: [
								'Realtor.OBJECT.INPUT.MODERNIZATION.RenewalsSteps.step2'
							],
							sentinal: 'Realtor.OBJECT.INPUT.MODERNIZATION.RenewalsSteps.step1',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					.value( this.m_Data.Data.Modernization.Renewals.Bathrooms.status ),
					[ 'col-xs-12', 'col-md-5' ]
				);
				addObjDataInput(
					new ui.Form.TextInput( this.m_Data.Data.Modernization.Renewals.Bathrooms.year || '', { name: 'Renewals.Bathrooms.year', placeholder: '', required: false } ).rebuild( fg ),
					[ 'col-xs-12', 'col-md-2' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.Renewals.Groundplan' ) ).addClass( 'control-label col-xs-12 col-md-5' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.LabelledSlider(
						{
							name: 'Renewals.Groundplan.status',
							required: false,
							value: [
								'Realtor.OBJECT.INPUT.MODERNIZATION.RenewalsSteps.step2'
							],
							sentinal: 'Realtor.OBJECT.INPUT.MODERNIZATION.RenewalsSteps.step1',
							control: true
						},
						(text: string) => app.getMessage( text )
					).rebuild( fg )
					.value( this.m_Data.Data.Modernization.Renewals.Groundplan.status ),
					[ 'col-xs-12', 'col-md-5' ]
				);
				addObjDataInput(
					new ui.Form.TextInput( this.m_Data.Data.Modernization.Renewals.Groundplan.year || '', {name: 'Renewals.Groundplan.year',	placeholder: '', required: false } ).rebuild( fg ),
					[ 'col-xs-12', 'col-md-2' ]
				);

				// Sonstige
				fg = ui.$$.div()
				.append( ui.$$.h( 6, app.getMessage( 'Realtor.OBJECT.LABEL.MODERNIZATION.Others' ) ).addClass( 'text-muted col-xs-12 col-md-12' ) )
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.Others.Appreciation' ) ).addClass( 'control-label col-xs-12 col-md-12' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.TextArea(
							{
								name: 'Others.Appreciation',
								rows: 3,
								css:
								{
									resize: 'vertical',
								},
								required: false
							}
						).value(this.m_Data.Data.Modernization.Others.Appreciation)
					.rebuild( fg ),
					[ 'col-xs-12', 'col-md-12' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.Others.ConstructionDefects' ) ).addClass( 'control-label col-xs-12 col-md-12' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.TextArea(
						{
							name: 'Others.ConstructionDefects',
							rows: 3,
							css:
							{
								resize: 'vertical'
							},
							required: false
						}
					).value(this.m_Data.Data.Modernization.Others.ConstructionDefects)
					.rebuild( fg ),
					[ 'col-xs-12', 'col-md-12' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.Others.Maintenance' ) ).addClass( 'control-label col-xs-12 col-md-12' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.TextArea(
						{
							name: 'Others.Maintenance',
							rows: 3,
							css:
							{
								resize: 'vertical'
							},
							required: false
						}
					).value(this.m_Data.Data.Modernization.Others.Maintenance)
					.rebuild( fg ),
					[ 'col-xs-12', 'col-md-12' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.Others.Depreciation' ) ).addClass( 'control-label col-xs-12 col-md-12' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.TextArea(
						{
							name: 'Others.Depreciation',
							rows: 3,
							css:
							{
								resize: 'vertical'
							},
							required: false
						}
					).value(this.m_Data.Data.Modernization.Others.Depreciation)
					.rebuild( fg ),
					[ 'col-xs-12', 'col-md-12' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.MODERNIZATION.Others.Remarks' ) ).addClass( 'control-label col-xs-12 col-md-12' ) ).appendTo( this.m_Modernization.Root() );
				addObjDataInput(
					new ui.Form.TextArea(
						{
							name: 'Others.Remarks',
							rows: 3,
							css:
							{
								resize: 'vertical'
							},
							required: false
						}
					).value(this.m_Data.Data.Modernization.Others.Remarks)
					.rebuild( fg ),
					[ 'col-xs-12', 'col-md-12' ]
				);

			}

		}

	}
}
